import React from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import { popoverHelperActions, resolveAnchorEl, } from 'src/components/20-helper-views/popover/usePopover';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import SelectExamLevelOverlayContent from './components/SelectExamLevelOverlayContent';
import { EXAM_LEVEL_SELECT_POPOVER_LIST_HEIGHT } from './types';
export default function useData({ value, onChange }) {
    const [{ deviceType }] = useTheme();
    const closeOverlay = useStableCallback(() => {
        bottomDrawerHelperActions.hide();
        popoverHelperActions.hide();
    });
    const handleCommit = useStableCallback((newValue) => {
        closeOverlay();
        onChange(newValue);
    });
    const initiateSelectionFlow = useCallbackWithCtx((ctx, anchorRef) => {
        const content = (React.createElement(SelectExamLevelOverlayContent, { value: ctx.value, onChange: handleCommit, layout: ctx.deviceType.isPhone ? 'drawer' : 'popover' }));
        if (ctx.deviceType.isPhone) {
            bottomDrawerHelperActions.show({ component: content });
            return;
        }
        popoverHelperActions.show({
            anchorEl: resolveAnchorEl(anchorRef.current),
            matchAnchorWidth: true,
            paperSx: { maxHeight: EXAM_LEVEL_SELECT_POPOVER_LIST_HEIGHT + 56 },
            component: content,
            onClose: closeOverlay,
        });
    }, { value, deviceType });
    const state = {};
    const actions = { initiateSelectionFlow };
    return [state, actions];
}
